import { transformData } from 'hooks'
import styled from 'styled-components'

const StyledSpan = styled.span``

interface IProps {
  from?: number
  to?: number
}

export enum ActionType {
  Edit,
  Delete,
  Reload,
  Accept
}

const TimeSlot = ({ from, to }: IProps) => {
  const { timeSLotPipe } = transformData()
  return (
    <StyledSpan className="time-slot">
      <span>{timeSLotPipe(from)}</span> - <span>{timeSLotPipe(to)}</span>
    </StyledSpan>
  )
}

export default TimeSlot
